import { render } from "./switch.html?vue&type=template&id=4a1e2793&scoped=true&ts=true"
import script from "./switch.ts?vue&type=script&lang=ts"
export * from "./switch.ts?vue&type=script&lang=ts"

import "./switch.scss?vue&type=style&index=0&id=4a1e2793&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1e2793"]])

export default __exports__